import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputSelect } from '@/components';
import type { FilterState } from '@/features/filterSlice';
import { FilterSection } from './FilterSection';
import { useFetchUpdatedAtYearQuery } from '@/features/fieldSlice';
import { useClientTerminology } from '@/views/list/NetworkTerms';

const AnalysisYearFilter = (props: {
  control: Control<FilterState>;
  showTitle?: boolean;
}) => {
  const control = props.control;
  const { formatMessage } = useClientTerminology();

  const { data: updatedAtYears, error: error } = useFetchUpdatedAtYearQuery();
  const yearOptions = (updatedAtYears ?? []).map((year) => ({
    value: year,
    label: year,
  }));

  const showFilter = (updatedAtYears ?? []).length > 1;

  if (error || !showFilter) {
    return null;
  }

  return (
    <FilterSection
      title={
        props.showTitle !== false
          ? formatMessage({ id: 'filter.analysisDateTitle' })
          : undefined
      }
    >
      <Controller
        control={control}
        name="updatedAtYears"
        render={({ field: { onChange, onBlur, value } }) => {
          return (
            <InputSelect
              isMulti={true}
              label={formatMessage({ id: 'filter.lastAnalyzedLabel' })}
              placeholder={formatMessage({ id: 'filter.allYearsPlaceholder' })}
              options={yearOptions}
              onChange={onChange}
              onBlur={onBlur}
              value={yearOptions.filter((option) =>
                value?.includes(option.value)
              )}
            />
          );
        }}
      />
    </FilterSection>
  );
};

export default AnalysisYearFilter;
